module.exports = __webpack_public_path__ + "static/media/x.ccb6b7c1.svg";